import { axiosPrivateWBO } from '../api/axiosWBO'
import { useEffect } from 'react'

import useRefreshData from './useRefreshData'
import useAuth from './useAuth'

const useAxiosPrivateWBO = () => {
  const { auth } = useAuth()

  const refresh = useRefreshData()

  useEffect(() => {
    const requestIntercept = axiosPrivateWBO.interceptors.request.use(
      (config) => {
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = `Bearer ${auth?.token}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    const responseIntercept = axiosPrivateWBO.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config
        if (error?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true
          prevRequest.headers['Authorization'] = `Bearer ${auth.token}`
          return axiosPrivateWBO(prevRequest)
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axiosPrivateWBO.interceptors.request.eject(requestIntercept)
      axiosPrivateWBO.interceptors.response.eject(responseIntercept)
    }
  }, [auth, refresh])

  return axiosPrivateWBO
}

export default useAxiosPrivateWBO
